import CryptoJS from 'crypto-js';

export const encrypt = (text, key) => {
  const cipherText = CryptoJS.AES.encrypt(text, key);
  return cipherText.toString();
};

export const decrypt = (text, key) => {
  const bytes = CryptoJS.AES.decrypt(text, key);
  return bytes.toString(CryptoJS.enc.Utf8);
};